import { MultilineText } from "./components/MultilineText";

interface MultilineTextInput {
  content: string;
  isMarkdown: boolean;
}

export function markdownInput(content: string): MultilineTextInput {
  return {
    content,
    isMarkdown: true,
  };
}

/**
 * Helper to be used for input forms where we expact a MultilineText to
 * be markdown content.
 */
export function extractMarkdownContent(body: MultilineText): string {
  // TODO: We should probably rewrite the markdown editing so that
  //  it maps more properly to MultilineText, so that we get rid
  //  of the assertions here.
  if (!body.isMarkdown) {
    //captureWarn("Expected markdown content, but the element was not markdown");
  }

  return body.content;
}

export function extractNullableMarkdownContent(
  body: MultilineText | null,
): string | null {
  return body == null ? null : extractMarkdownContent(body);
}
